import * as yup from 'yup';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';

interface LinkBlot {
  statics: { blotName: string };
  domNode: HTMLElement;
  format(name: string, value: string): void;
}

interface LinkBlotStatic {
  new (...args: never[]): LinkBlot;
  create(value: string): HTMLElement;
}

const Link = ReactQuill.Quill.import('formats/link') as LinkBlotStatic;

const linkSchema = yup
  .string()
  .matches(/https:\/\//)
  .url();

const showErrorMessage = () =>
  toast.error('Wprowadzony link jest nieprawidłowy. Pamiętaj, że link musi rozpoczynać się od "https://"', {
    toastId: 'editorLinkError',
  });

class CustomLink extends Link {
  static override create(value: string) {
    const node = super.create(value);
    void linkSchema.isValid(value).then((isValid) => {
      if (!isValid) {
        showErrorMessage();
        node.removeAttribute('href');
      }
    });
    return node;
  }

  override format(name: string, value: string) {
    super.format(name, value);
    if (name !== this.statics.blotName || !value) return;
    void linkSchema.isValid(value).then((isValid) => {
      if (!isValid) {
        showErrorMessage();
        this.domNode.removeAttribute('href');
      }
    });
  }
}

export default CustomLink;
